import React from "react";
import Marquee from "react-fast-marquee";

// === KOT Corporate Company logos ===
import logoDS from "../../../images/companies/digital-systems.png";
import logoAF from "../../../images/companies/appforge.png";
import logoGIQ from "../../../images/companies/growth-iq.png";
import logoVS from "../../../images/companies/visual-systems.png";
import logoPS from "../../../images/companies/platform-systems.png";
import logoET from "../../../images/companies/epitech.png";
import logoCX from "../../../images/companies/commerce-x.png";
import logoFX from "../../../images/companies/flawless-x.png";
import logoVX from "../../../images/companies/venture-xcelerator.png";
import logoTFTX from "../../../images/companies/the-founders-tx.png";

const BrandSection: React.FC = () => {
    const brandLogos = [
        logoDS,
        logoAF,
        logoVX,
        logoET,
        logoTFTX,
        logoCX,
        logoGIQ,
        logoVS,
        logoPS,
        logoFX,
    ];

    return (
        <section className="brand pb-150">
            <div className="container">
                <div className="sec-title sec-title-center brand-sec-title text-center mb-40">
                    <p className="sub-title">
                        One Group — <span>10 Companies & 5 Programs</span> Working as One Ecosystem
                    </p>
                </div>
            </div>

            {/* === Marquee — corporate company logos === */}
            <Marquee
                gradient={false}
                speed={30}
                pauseOnHover
                direction="left"
                className="brand-marquee ac-brand-marquee marquee-left"
            >
                <div className="ac-brand-inner ul_li_between">
                    {brandLogos.map((logo, i) => (
                        <div key={i} className="xb-brand-item xb-brand-item--company">
                            <img src={logo} alt={`KOT company ${i + 1}`} />
                        </div>
                    ))}
                </div>
            </Marquee>
        </section>
    );
};

export default BrandSection;
